import { render, staticRenderFns } from "./KiraKiraPack01.vue?vue&type=template&id=044c7a37&scoped=true&"
import script from "./KiraKiraPack01.vue?vue&type=script&lang=js&"
export * from "./KiraKiraPack01.vue?vue&type=script&lang=js&"
import style0 from "./KiraKiraPack01.vue?vue&type=style&index=0&id=044c7a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c7a37",
  null
  
)

export default component.exports